<template>
  <div style="text-align: center;">
    <h1 v-if="isExclusive">{{ $t('contract.header.title_exclusive') }}</h1>
    <h1 v-else>{{ $t('contract.header.title_non_exclusive') }}</h1>
    <transition name="highlight">
      <h6
        class="sub-title"
        v-show="isDistributorType"
      >{{ $t('contract.header.subtitle_distributor') }}</h6>
    </transition>
    <transition name="highlight">
      <h6
        class="sub-title"
        v-show="!isDistributorType"
      >{{ $t('contract.header.subtitle_supplier') }}</h6>
    </transition>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    isDistributorType() {
      return this.$store.getters.isDistributorType;
    },
    isExclusive() {
      return this.$store.getters.isExclusive;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/Header.vue